module.exports = __webpack_public_path__ + "media/images/talent/case-reward02-8039f724cabb263f2efcda22ebc6a1e5.png";